document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-site-nav]');
  toggle?.addEventListener('click',()=>{
    const open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));
    nav?.classList.toggle('is-open',!open);
    document.body.classList.toggle('menu-open',!open);
  });
  nav?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{
    toggle?.setAttribute('aria-expanded','false');
    nav.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }));
  document.querySelectorAll('.product-form').forEach(form=>{
    const select=form.querySelector('[data-variant-select]');
    const price=form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const button=form.querySelector('[data-add-button]');
    select?.addEventListener('change',()=>{
      const option=select.options[select.selectedIndex];
      if(price&&option.dataset.price) price.textContent=option.dataset.price;
      if(button){button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?button.dataset.addText:button.dataset.soldText;}
      const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);
    });
  });
});
